import { OdgEvaluationNote } from '../models/odg.model';
import { SmileyBase } from './smiley-base';
import { EventEmitter } from '@angular/core';
export class OdgSmileyPasConsommeComponent extends SmileyBase {
    constructor() {
        super(...arguments);
        this.readonly = false;
        this.smileyClick = new EventEmitter();
        this.note = OdgEvaluationNote.PasConsomme;
    }
}
